<template>
  <div>
    <label>
      <span class="label">
        <FontAwesomeIcon v-if="icon" :icon="icon"/>
        {{ label }}
      </span>
      <slot />
      <span class="error-message">
        <span v-show="errorMessage">
          <FontAwesomeIcon icon="exclamation-circle" />
        </span>
        {{ errorMessage }}
      </span>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'recyco-generic-input-component',
    props: {
      label: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
      },
      validate: {
        type: Function,
        default: () => null,
      },
      value: {
        default: '',
      },
    },
    data() {
      return {
        errorMessage: '',
      };
    },
    methods: {
      input(event) {
        const { value } = event.target;
        this.errorMessage = this.validate(value);
      },
    },
    watch: {
      value(value) {
        this.errorMessage = this.validate(value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  label {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .label {
    text-align: left;
    margin-left: 1.5em;
    margin-right: 1.5em;
  }

  .error-message {
    font-size: 0.75em;
    margin-top: 0.25em;
    color: var(--color-danger);
    text-align: start;
    margin-left: 1.333em;
    margin-right: 1.333em;
    min-height: 1.3em;
  }
</style>
